var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInfoGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00065 0.333496C3.32065 0.333496 0.333984 3.32016 0.333984 7.00016C0.333984 10.6802 3.32065 13.6668 7.00065 13.6668C10.6807 13.6668 13.6673 10.6802 13.6673 7.00016C13.6673 3.32016 10.6807 0.333496 7.00065 0.333496ZM7.00065 10.3335C6.63398 10.3335 6.33398 10.0335 6.33398 9.66683V7.00016C6.33398 6.6335 6.63398 6.3335 7.00065 6.3335C7.36732 6.3335 7.66732 6.6335 7.66732 7.00016V9.66683C7.66732 10.0335 7.36732 10.3335 7.00065 10.3335ZM7.66732 5.00016H6.33398V3.66683H7.66732V5.00016Z",
    fill: "#959595"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfoGray);
export default __webpack_public_path__ + "static/media/icon_info_gray.8b99d8cf9967fe3f23cf250b1f390ff3.svg";
export { ForwardRef as ReactComponent };